var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStok = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 9.16797C7.33333 8.89263 7.108 8.66797 6.83333 8.66797H4.33333V10.668C4.33333 11.036 4.03467 11.3346 3.66667 11.3346C3.29867 11.3346 3 11.036 3 10.668V8.66797H0.5C0.224667 8.66797 0 8.89263 0 9.16797V15.5013C0 15.7766 0.224667 16.0013 0.5 16.0013H6.83333C7.108 16.0013 7.33333 15.7766 7.33333 15.5013V9.16797Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 9.16797C16.0003 8.89263 15.775 8.66797 15.5003 8.66797H13.0003V10.668C13.0003 11.036 12.7017 11.3346 12.3337 11.3346C11.9657 11.3346 11.667 11.036 11.667 10.668V8.66797H9.16699C8.89166 8.66797 8.66699 8.89263 8.66699 9.16797V15.5013C8.66699 15.7766 8.89166 16.0013 9.16699 16.0013H15.5003C15.775 16.0013 16.0003 15.7766 16.0003 15.5013V9.16797Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 0.5C11.6663 0.225333 11.441 0 11.1663 0H8.66633V2C8.66633 2.368 8.36767 2.66667 7.99967 2.66667C7.63167 2.66667 7.333 2.368 7.333 2V0H4.83301C4.55767 0 4.33301 0.225333 4.33301 0.5V6.83333C4.33301 7.10867 4.55767 7.33333 4.83301 7.33333H11.1663C11.441 7.33333 11.6663 7.10867 11.6663 6.83333V0.5Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStok, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stok.901f7b91.svg";
export { ForwardRef as ReactComponent };